import type { FlotiqEventApiItem } from "@jti/fe-common";

import type { FlotiqEventStore } from "../types";

const transformEventMarker = (marker: FlotiqEventApiItem): FlotiqEventStore => {
  const { Street, City, ZipCode, State, Country, EventName, EventId, ...rest } = marker.item;
  const address = [Street, City, ZipCode, State, Country].filter(Boolean).join(", ");

  return {
    ...rest,
    Street,
    City,
    ZipCode,
    State,
    Country,
    StoreName: EventName ?? "",
    ExternalId: EventId ?? marker.item.id,
    address,
  };
};

export const getTransformedEventMarkers = (items: FlotiqEventApiItem[]): FlotiqEventStore[] =>
  items.filter((marker) => marker.item.Status !== false).map(transformEventMarker);
